import React, { useEffect, useRef, useState } from "react"
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Divider,
  FormControl,
  Grid,
  Typography,
} from "@mui/material"
import { FaChevronDown, FaChevronLeft, FaChevronUp, FaStar } from "react-icons/fa6"
import * as Style from "../ProviderLayout/Style1"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from "@mui/lab"
import {
  useGenrateOtpMutation,
  useProviderJobPostQuery,
  useTimeLineProviderQuery,
  useVerifyOtpMutation,
} from "../../features/Auth/authApi"
import moment from "moment"
import { toast } from "react-toastify"
import chat from "../../images/chat.svg"
import RocketIcon from "../../images/rocket.png"
import CenteredSpinner from "../common/CenteredSpinner"
import servicecompleted from "../../images/servicecompleted.png"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import GenRateotpCustomer from "./genrateOtp"
import { useCreateTicketMutation } from "../../features/ChatAuth/chatApi"
import PreviewImage from "../common/previewImage"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
const VerifyOtp = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [otp, setOtp] = useState(["", "", "", "", "", ""])
  const otpRef = useRef<HTMLInputElement[]>([])
  const [showOtp, setShowOtp] = useState<string>("")
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [showExtraDetails, setShowExtraDetails] = useState(false)
  // more button handle for timeline
  const [showFullTimeline, setShowFullTimeline] = useState(false)
  const [chatView, { data: CharacterData }] = useCreateTicketMutation()
  const handleToggleTimeline = () => {
    setShowFullTimeline(!showFullTimeline)
  }

  const handleChatView = async () => {
    const payload = {
      postId: id,
    }

    try {
      const response: any = await chatView(payload)
      if (response?.data?.status === 200) {
        const chatId = response.data?.data?._id
        const adminId = response.data?.data?.adminstration

        if (chatId && adminId) {
          navigate(`/dashboard/help-center?chatId=${chatId}&adminId=${adminId}`)
        } else {
          console.error("Invalid chatId or adminId in response:", response)
        }
      } else {
        console.error("API call was not successful:", response)
      }
    } catch (error) {
      console.error("Error making API call:", error)
    } finally {
    }
  }

  const [
    verifyOptConfirm,
    { data: otpData, error: otpError, isLoading: otpIsloading },
  ] = useVerifyOtpMutation()
  const { data: timeLine } = useTimeLineProviderQuery({ postId: id })

  const { data: activePostData, isLoading: activeIsloading } =
    useProviderJobPostQuery()

  const [
    getrateOtpProvider,
    { data: otpgenRateData, error: otpgenError, isLoading: genRateLoading },
  ] = useGenrateOtpMutation()

  useEffect(() => {
    if (otpgenRateData?.data) {
      setShowOtp(otpgenRateData?.data?.otp)
    }
  }, [otpgenRateData])

  const handleVerifyClickOpen = () => {
    const payload = {
      postId: id,
    }

    getrateOtpProvider(payload)
  }
  const clearStoredOtp = (postId: string) => {
    localStorage.removeItem(`otp_${postId}`);
  };

  useEffect(() => {
    if (otpgenRateData?.data && otpgenRateData?.message) {
      toast.success(otpgenRateData?.message)
      setShowOtp(otpgenRateData?.data?.otp);
      localStorage.setItem(`otp_${id}`, otpgenRateData?.data?.otp);
    } else {
      toast.error((otpgenError as any)?.data?.message)
    }
  }, [otpgenRateData, otpgenError]);

  const conFirmOtp = () => {
    setShowOtp("") as any
    const payload = {
      postId: id,
      jobAction:
        activePostData?.data?.ifJobEndOtpGenBySeeker == true &&
          activePostData?.data?.status == "Completed"
          ? "End"
          : "Start",
      otp: otp.join(""),
    }
    verifyOptConfirm(payload)
    clearStoredOtp(id as string);
  }

  const handleKeyDownConfirmOtp = (event: any) => {
    if (event.key === "Enter") {
      conFirmOtp()
    }
  }

  // opt handler

  const handleChange = (index: any, event: any) => {
    const newOtp = [...otp]
    const newValue = event.target.value

    if (!otp[index]) {
      newOtp[index] = newValue
    } else {
      newOtp[index] = newValue
    }

    setOtp(newOtp)

    if (event.target.nextSibling && newValue !== "") {
      event.target.nextSibling.focus()
    }
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const cleanText = pastedText.replace(/\D/g, '');

    if (cleanText.length >= 6) {
      const digits = cleanText.split('').slice(0, 6);

      setOtp(digits);

      setTimeout(() => {
        if (otpRef.current[5]) {
          otpRef.current[5].focus();
        }
      }, 10);
    }
  };

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    target.value = target.value.replace(/\D/g, '');
  };

  const handleKeyDown = (index: any, event: any) => {
    if (event.keyCode === 8 && !otp[index] && otpRef.current[index - 1]) {
      ; (otpRef as any).current[index - 1].focus()
    }
  }

  const handleClick = (index: number) => {
    ; (otpRef as any).current[index].focus()
  }

  useEffect(() => {
    if (otpData?.message && otpData?.data?.isVerified === undefined) {
      toast.success(otpData?.message)
      setOtp(["", "", "", "", "", ""])
    } else {
      toast.error((otpError as any)?.data?.message)
    }
  }, [otpData, otpError])

  useEffect(() => {
    if (otpData?.data?.isVerified === true) {
      toast.success(otpData?.message)
      setOtp(["", "", "", "", "", ""])
    } else if (otpData?.data?.isVerified === false) {
      toast.error((otpError as any)?.data?.message)
    }
  }, [otpData, otpError])

  useEffect(() => {
    if (activePostData?.data?.isData === false) {
      navigate(`/dashboard/write-review/${activePostData?.data?.seekerData?._id}?postId=${id}`)
    } else if (activePostData?.data?.status == "Expired") {
      navigate("/dashboard")
    } else if (activePostData?.data?.isData == true) {
      navigate(`/dashboard/write-review/${activePostData?.data?.seekerData?._id}?postId=${id}`)
    }
  }, [activePostData])

  // image preview  with on click

  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClosePreview = () => {
    setSelectedImage(null)
  }

  const handleWriteReview = () => {
    navigate(`/dashboard/write-review/${activePostData?.data?.seekerData?._id}?postId=${id}`)
  }
  return (
    <>
      <Box>
        <Style.Overview>
          {activeIsloading ? (
            <CenteredSpinner />
          ) : (
            <>
              <Box className="d-flex justify-content-between align-items-center pb-5">
                <Box className="d-flex align-items-center gap-4">
                  <Button
                    className="back-btn mb-0"
                    onClick={() => navigate("/dashboard")}
                  >
                    <FaChevronLeft />
                  </Button>
                </Box>
                <Box>
                  <Typography className="status-text mb-0 ">
                    Status-{" "}
                    <span className="completed fw-bold">
                      {activePostData?.data?.status}
                    </span>{" "}
                  </Typography>
                </Box>
              </Box>

              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{ mb: 5 }}
              >
                {activePostData?.data?.activeJobflow !== "END_OTP_VERIFIED" &&
                  activePostData?.data?.activeJobflow !== "PAYMENT_SUCCESS" && (
                    <Grid item xs={12} lg={6} order={{ xs: 2, lg: 1 }}>
                      <Typography
                        align="left"
                        variant="h2"
                        className=" fw-medium font-24"
                        mb={1}
                      >
                        Service Details
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        className="otp-box otp-box-3 p-4"
                        sx={{ mt: 1 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              maxHeight: "260px", // Set scroll area height
                              overflowY: "auto",
                              pr: 1, // Extra padding to avoid hiding content under scrollbar
                            }}
                          >
                            {/* Service required */}
                            <Box
                              sx={{
                                border: "1px solid #D3D3D3",
                                borderRadius: "8px",
                                p: 2,
                                mb: 2,
                                backgroundColor: "#F8F8F8",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                mb={1}
                              >
                                Service Required
                              </Typography>
                              <Typography variant="body1">
                                {activePostData?.data?.service?.name}
                              </Typography>
                            </Box>

                            {/* Service date */}
                            <Box
                              sx={{
                                border: "1px solid #D3D3D3",
                                borderRadius: "8px",
                                p: 2,
                                mb: 2,
                                backgroundColor: "#F8F8F8",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                mb={1}
                              >
                                Service Date
                              </Typography>
                              <Typography variant="body1">
                                {moment(activePostData?.data?.from).format(
                                  "DD-MM-YYYY",
                                )}
                              </Typography>
                            </Box>

                            {/* Service time */}
                            <Box
                              sx={{
                                border: "1px solid #D3D3D3",
                                borderRadius: "8px",
                                p: 2,
                                mb: 2,
                                backgroundColor: "#F8F8F8",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                mb={1}
                              >
                                Service Time
                              </Typography>
                              <Box className="d-flex gap-4">
                                <Typography variant="body1">
                                  <FormatChangeTime
                                    dateString={activePostData?.data?.from}
                                  />
                                </Typography>
                                <Typography variant="body1">
                                  <FormatChangeTime
                                    dateString={activePostData?.data?.till}
                                  />
                                </Typography>
                              </Box>
                            </Box>

                            {/* Language */}
                            <Box
                              sx={{
                                border: "1px solid #D3D3D3",
                                borderRadius: "8px",
                                p: 2,
                                mb: 2,
                                backgroundColor: "#F8F8F8",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                mb={1}
                              >
                                Language
                              </Typography>
                              <Typography variant="body1">
                                {activePostData?.data?.language?.join(" ")}
                              </Typography>
                            </Box>

                            {/* Location */}
                            <Box
                              sx={{
                                border: "1px solid #D3D3D3",
                                borderRadius: "8px",
                                p: 2,
                                mb: 2,
                                backgroundColor: "#F8F8F8",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                mb={1}
                              >
                                Location
                              </Typography>
                              <Typography variant="body1">
                                {activePostData?.data?.location}
                              </Typography>
                            </Box>

                            {/* Additional instructions */}
                            {activePostData?.data?.description && (
                              <Box
                                sx={{
                                  border: "1px solid #D3D3D3",
                                  borderRadius: "8px",
                                  p: 2,
                                  mb: 2,
                                  backgroundColor: "#F8F8F8",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  fontWeight="bold"
                                  mb={1}
                                >
                                  Additional Instructions
                                </Typography>
                                <Typography variant="body1">
                                  {activePostData?.data?.description}
                                </Typography>
                              </Box>
                            )}

                            {/* Attachments */}
                            {activePostData?.data?.attachments?.length > 0 && (
                              <Box
                                sx={{
                                  border: "1px solid #D3D3D3",
                                  borderRadius: "8px",
                                  p: 2,
                                  mb: 2,
                                  backgroundColor: "#F8F8F8",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  fontWeight="bold"
                                  mb={1}
                                >
                                  Photo
                                </Typography>
                                <Grid container spacing={2}>
                                  {activePostData?.data?.attachments?.map(
                                    (item: any, index: number) => (
                                      <Grid
                                        item
                                        xs={6}
                                        sm={4}
                                        md={3}
                                        key={index}
                                      >
                                        <img
                                          src={item}
                                          alt={`attachment-${index}`}
                                          className="photo-upload"
                                          style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => handleImageClick(item)}
                                        />
                                      </Grid>
                                    ),
                                  )}
                                </Grid>

                                <PreviewImage
                                  selectedImage={selectedImage}
                                  handleClosePreview={handleClosePreview}
                                />
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                <Grid item xs={12} lg={6} order={{ xs: 1, lg: 2 }}>
                  {(activePostData?.data?.activeJobflow == "JOB_ACTIVE" ||
                    activePostData?.data?.activeJobflow ==
                    "CUSTOMER_STOP_OTP") && (
                      <>
                        <Typography
                          align="left"
                          variant="h2"
                          className=" fw-medium font-24"
                          mb={1}
                        >
                          Enter Code{" "}
                        </Typography>
                        <Box className="otp-box text-center" sx={{ mt: 1 }}>
                          <Typography
                            align="center"
                            variant="h2"
                            className=""
                            mb={5}
                          >
                            To{" "}
                            {activePostData?.data?.ifJobEndOtpGenBySeeker ==
                              true && activePostData?.data?.status == "Completed"
                              ? "End"
                              : "Start"}{" "}
                            A Service, Enter A 6 Digit Code, Given By Customer.{" "}
                          </Typography>
                          <Box py={5}>
                            <FormControl className="d-flex justify-content-center gap-3 flex-row">
                              {otp.map((digit: any, index: number) => (
                                <input
                                  key={index}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) => handleChange(index, e)}
                                  onKeyDown={(e) => handleKeyDown(index, e)}
                                  onKeyPress={(event) => {
                                    const keyCode = event.keyCode || event.which
                                    const keyValue = String.fromCharCode(keyCode)
                                    const numericRegex = /^[0-9]+$/

                                    if (!numericRegex.test(keyValue)) {
                                      event.preventDefault()
                                    }
                                  }}
                                  onPaste={handlePaste}
                                  onInput={handleInput}
                                  onClick={() => handleClick(index)}
                                  ref={(ref: any) =>
                                    (otpRef.current[index] = ref as any)
                                  }
                                  style={{
                                    maxWidth: "clamp(30px, 3vw, 46px)",
                                    height: "clamp(30px, 3vw, 56px)",
                                    textAlign: "center",
                                    fontFamily: "Montserrat",
                                    color: "#F475A4",
                                    border: "1px solid #F475A4",
                                    borderRadius: "6px",
                                    fontSize: "20px",
                                  }}
                                />
                              ))}
                            </FormControl>
                          </Box>
                          <Button
                            className="view-profile py-2 text-capitalize"
                            onClick={conFirmOtp}
                            disabled={otp[0] == ""}
                            type="button"
                            tabIndex={0}
                            onKeyDown={handleKeyDownConfirmOtp}
                          >
                            {otpIsloading ? (
                              <Typography fontSize={1}>
                                <CircularProgress
                                  style={{ color: "pink", fontSize: 20 }}
                                  size={20}
                                />
                              </Typography>
                            ) : (
                              " Confirm Code"
                            )}
                          </Button>
                        </Box>
                      </>
                    )}
                  <>
                    <Typography
                      variant="body1"
                      className="mb-1"
                      style={{
                        color: "green",
                        fontSize: "large",
                        fontWeight: "bold",
                      }}
                    >
                      {activePostData?.data?.activeJobflow ==
                        "START_OTP_VERIFIED" && (
                          <>
                            <Typography
                              align="left"
                              variant="h2"
                              className=" fw-medium font-24"
                              mb={1}
                            >
                              Current Status{" "}
                            </Typography>
                            <Box
                              className="otp-box h-100 text-center d-flex flex-column align-items-center justify-content-center"
                              sx={{ mt: 1 }}
                            >
                              <Typography
                                align="center"
                                variant="body1"
                                className="green-heading"
                                mb={2}
                              >
                                Your Service Has Started{" "}
                              </Typography>
                              <Grid container justifyContent="center">
                                <img
                                  src={RocketIcon}
                                  alt="service started"
                                  height={180}
                                  width={180}
                                />
                              </Grid>
                            </Box>
                          </>
                        )}
                    </Typography>
                  </>

                  {(activePostData?.data?.activeJobflow == "STOP_SERVICE" ||
                    activePostData?.data?.activeJobflow ==
                    "PROVIDER_STOP_OTP") && (
                      <GenRateotpCustomer
                        otpGenrate={handleVerifyClickOpen}
                        otpFill={activePostData?.data?.endJobOtp || ""}
                        genRateLoading={genRateLoading}
                      />
                    )}
                </Grid>
              </Grid>

              {(activePostData?.data?.activeJobflow == "END_OTP_VERIFIED" ||
                activePostData?.data?.activeJobflow == "PAYMENT_SUCCESS") && (
                  <Grid container spacing={2} style={{ marginBottom: "50px" }}>
                    <Grid item xs={12} lg={7}>
                      <Box
                        className="otp-box h-100 text-center d-flex flex-column align-items-center justify-content-center"
                        sx={{ mt: 1 }}
                      >
                        <Typography
                          align="center"
                          variant="body1"
                          className="green-heading1 p-2"
                          mb={2}
                        >
                          Write a Review For Your Customer
                          {/* Total Amount{" "} */}
                          <span style={{ color: "#FFB800" }}>
                            {/* C${activePostData?.paymentDetails?.totalAmount} */}
                          </span>{" "}
                        </Typography>
                        {/* <Typography
                        align="center"
                        variant="body1"
                        className="payment-status"
                        mb={2}
                      >
                        Payment Status
                        <button className="pending"> Pending</button>
                      </Typography> */}
                        {/* <Typography
                        align="center"
                        variant="body1"
                        className="text-data mt-2"
                        mb={3}
                      >
                        (Ask Customer To Pay The Amount){" "}
                      </Typography> */}
                        <Button
                          className="text-white py-2 px-4 text-capitalize"
                          onClick={handleWriteReview}
                          sx={{
                            background: "#F475A4",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "16px",
                            borderRadius: "8px",
                            textTransform: "capitalize",
                            padding: "10px 30px",
                            marginTop: "10px",
                            "&:hover": {
                              background: "#F475A4",
                              opacity: 0.9,
                              boxShadow: "0 4px 8px rgba(244, 117, 164, 0.3)",
                            },
                            "&:focus": {
                              background: "#F475A4",
                              outline: "none",
                              boxShadow: "0 0 0 3px rgba(244, 117, 164, 0.3)",
                            },
                          }}
                        >
                          Write Review
                        </Button>
                      </Box>{" "}
                    </Grid>
                    <Grid item xs={12} lg={5} className="d-none d-xl-block ">
                      <Box
                        sx={{
                          height: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "24px",
                            fontWeight: "700",
                            color: "#009C35",
                            marginTop: "15px",
                          }}
                        >
                          Service Completed Successfully!
                        </p>
                        <img
                          src={servicecompleted}
                          alt="Description"
                          style={{
                            width: "200px",
                            height: "auto",
                            marginTop: "15px",
                          }}
                        />
                      </Box>{" "}
                    </Grid>
                  </Grid>
                )}

              {/* Additional Info Section - Below the service details container */}
              {activePostData?.data?.activeJobflow !== "END_OTP_VERIFIED" &&
                activePostData?.data?.activeJobflow !== "PAYMENT_SUCCESS" && (
                  <Box className="py-2 px-0 bg-white my-2" sx={{ maxHeight: "500px", borderRadius: "18px" }}>
                    {activePostData?.data?.extraDetails && (
                      <Box className="px-4 mt-2">
                        <Button
                          variant="outlined"
                          onClick={() => setShowExtraDetails(!showExtraDetails)}
                          className="text-capitalize d-flex align-items-center gap-2"
                          style={{
                            borderColor: "#F475A4",
                            color: "#F475A4",
                            fontWeight: "600",
                            padding: "8px 16px",
                          }}
                        >
                          {showExtraDetails ? (
                            <>
                              <FaChevronUp size={14} />
                              Hide Additional Information
                            </>
                          ) : (
                            <>
                              <FaChevronDown size={14} />
                              Show Additional Information
                            </>
                          )}
                        </Button>

                        <Collapse in={showExtraDetails}>
                          <Box className="mt-3 p-2 border rounded">
                            <ExtraDetailsDisplay
                              extraDetails={activePostData?.data?.extraDetails}
                              serviceName={activePostData?.data?.service?.name}
                            />
                          </Box>
                        </Collapse>
                      </Box>
                    )}
                  </Box>
                )}
              <Divider className="dark-divider mb-5" />

              <Box
                className="d-flex mb-5"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  align="left"
                  variant="h2"
                  className=" font-20"
                  mb={2}
                >
                  Timeline
                </Typography>

                <Box display="flex">
                  <Button className="timeline-btn " onClick={handleChatView}>
                    Chat
                    <img
                      src={chat}
                      alt="chat"
                      style={{ color: "#F475A4", marginLeft: "10px" }}
                    />
                  </Button>
                </Box>
              </Box>
              <Box className="timeline-graph">
                {timeLine?.data
                  ?.slice(0, showFullTimeline ? timeLine?.data?.length : 3)
                  .map((timeline: any, index: number) => (
                    <Timeline
                      key={timeline._id}
                      position={index % 2 === 0 ? "alternate" : "left"}
                    >
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{ m: "10px 0 0" }}
                          align="right"
                          className="timeline-desc"
                          color="text.secondary"
                        >
                          <span className="datetime">
                            <span className="d-flex flex-column">
                              <span className="weekday">
                                <FormatDate dateString={timeline.createdAt} />
                              </span>
                              <span>
                                <FormatChangeTime
                                  dateString={timeline.createdAt}
                                />
                              </span>
                              <span>
                                <FormatTime dateString={timeline.createdAt} />
                              </span>
                            </span>
                          </span>

                          <br />
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot>
                            <Typography className="timeline-step">
                              0{timeLine?.data?.length - index}
                            </Typography>
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                          <Box className="timeline-content">
                            <Typography className="timeline-heading">
                              Status - {timeline?.postStatus}{" "}
                            </Typography>
                            <Typography className="timeline-desc"></Typography>
                            <Typography className="timeline-desc">
                              {timeline?.message}{" "}
                            </Typography>
                          </Box>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  ))}
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={handleToggleTimeline}
                    className="view-profile py-2 text-capitalize"
                  >
                    {showFullTimeline ? "Show Less" : "Show More"}
                  </Button>
                </div>
              </Box>
            </>
          )}
        </Style.Overview>
      </Box>
    </>
  )
}
export default VerifyOtp
